module.exports = __webpack_public_path__ + "img/wholemode_resources_rotate.fc747742.svg";